import { PixelConfigurationError } from './errors';

/** Tamanho máximo aceito para `identity.pixelId` após trim. */
export const PIXEL_ID_MAX_LENGTH = 128;

function hasControlChars(value: string): boolean {
  for (let i = 0; i < value.length; i += 1) {
    const code = value.charCodeAt(i);
    if (code <= 0x1f || (code >= 0x7f && code <= 0x9f)) {
      return true;
    }
  }
  return false;
}

/**
 * Normaliza e valida `identity.pixelId` em runtime (o bundle global é JS).
 * Não exige o prefixo `pix_`.
 */
export function normalizePixelId(value: unknown): string {
  if (typeof value !== 'string') {
    throw new PixelConfigurationError(
      'identity.pixelId must be a non-empty string.',
      'INVALID_PIXEL_ID'
    );
  }

  const normalized = value.trim();

  if (normalized.length === 0) {
    throw new PixelConfigurationError(
      'identity.pixelId must be a non-empty string.',
      'INVALID_PIXEL_ID'
    );
  }

  if (normalized.length > PIXEL_ID_MAX_LENGTH) {
    throw new PixelConfigurationError(
      `identity.pixelId exceeds the maximum length of ${PIXEL_ID_MAX_LENGTH} characters.`,
      'INVALID_PIXEL_ID'
    );
  }

  if (hasControlChars(normalized)) {
    throw new PixelConfigurationError(
      'identity.pixelId must not contain control characters.',
      'INVALID_PIXEL_ID'
    );
  }

  return normalized;
}
